export default __webpack_public_path__ + "0f0ee2f1903caf5f08e83cce70b96448.png";